import PropTypes from 'prop-types';
import React from 'react';
// material
import { Box, Grid, Container, Typography, Stack, useMediaQuery } from '@mui/material';
import { toast } from 'react-hot-toast';
import { useTheme } from '@mui/material/styles';
// components
import Page from '../components/Page';
import {
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppOrderTimeline,
  AppDomains,
  AppHostings,
  AppEmails,
  AppTTEs,
  ItemLayanan
} from '../components/_dashboard/app';
// services
import * as myLayananService from '../services/mylayanan';
import useWidth from '../hooks/useWidth';
import isEligible from '../utils/roleEligibleGetter';

// ----------------------------------------------------------------------

DashboardApp.propTypes = {
  user: PropTypes.object.isRequired
};

export default function DashboardApp({ user }) {
  const text = user?.attributes?.name;
  // const javanese = toJavanese(text, { useAccents: true, useSwara: true, useMurda: false });
  const width = useWidth(useTheme, useMediaQuery);
  const [aggregate, setAggregate] = React.useState([]);

  const getAggregate = async () => {
    try {
      const idInstansi = user?.attributes?.id_instansi;
      const role = user?.attributes?.role;
      const userID = user?.attributes?.id;
      if (!idInstansi && !role) return;

      const body = {
        id_instansi: idInstansi,
        role,
        user_id: userID
      };

      const result = await myLayananService.getLayananAggregate(body);

      setAggregate(result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getAggregate();
  }, [user]);
  return (
    <Page title="Dashboard | Peladen Pemda DIY">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4">{text}</Typography>
        </Box>
        <Stack direction="column" spacing={2}>
          {/* <Stack
            // flexWrap="wrap"
            direction={['xs', 'sm'].includes(width) ? 'column' : 'row'}
            spacing={2}
            // style={{ maxWidth: '100%', overflowX: 'scroll' }}
            sx={{
              maxWidth: '100%',
              overflowX: 'auto' // Mengatur scroll horizontal
            }}
          > */}
          <Box
            sx={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              '&::-webkit-scrollbar': { display: 'none' }
            }}
          >
            {aggregate.map((item) => (
              <Box
                sx={{
                  minWidth: '200px',
                  flex: '0 0 auto',
                  marginRight: 2
                }}
              >
                <ItemLayanan data={item} key={item.id} />
              </Box>
            ))}
            {/* <Grid container spacing={3}>
              {aggregate.map((item) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={item.id}>
                  <ItemLayanan data={item} />
                </Grid>
              ))}
            </Grid> */}
          </Box>
          <Stack direction={['xs', 'sm'].includes(width) ? 'column' : 'row'} spacing={2}>
            <Box sx={{ flex: ['xs'].includes(width) ? 12 : 8 }}>
              <AppNewsUpdate user={user} />
            </Box>

            {isEligible('activity_widget') && (
              <Box sx={{ flex: ['xs'].includes(width) ? 12 : 4 }}>
                <AppOrderTimeline user={user} />
              </Box>
            )}
          </Stack>
        </Stack>
      </Container>
    </Page>
  );
}
